export default __webpack_public_path__ + "static/media/shooting.3c64358b.jpg";